import { getInitialM } from '@shared/helpers/index.ts';
import type { Author } from '@shared/types/defaults';
import { DateViewer } from '@shared/ui/DateViewer/index.tsx';
import { ImageWithSkeleton } from '@shared/ui/img-with-skeleton/ui.tsx';
import { TextOverflow } from '@shared/ui/TextOverflow/index.tsx';
import * as st from './styles.module.scss';

type PT = {
  title: string;
  author: Author;
  img: string;
  created: string;
};

export const ListCard = (props: PT) => {
  const { title, author, img, created } = props;
  const { first_name, middle_name, last_name } = author;
  const authorInitial = getInitialM(first_name, middle_name, last_name);

  return (
    <article className={st.card}>
      <ImageWithSkeleton className={st.image} src={img} alt={`${title} promoImage`} />
      <section className={st.info}>
        <TextOverflow className={st.title}>{title}</TextOverflow>
        <div className={st.authorNameAndDate}>
          <TextOverflow className={st.author}>{authorInitial}</TextOverflow>
          <DateViewer className={st.date} value={created} />
        </div>
      </section>
    </article>
  );
};
